import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { SKID } from '~/constants/modules';
import { t, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/preset/actions';

import Form from './form';

function Preset() {
  const redux = useSelector((state) => state.preset);

  const options = useMemo(
    () =>
      can(SKID)
        ? [
            { label: 'L', value: t('s.geral.opcoes.liberado') },
            { label: 'B', value: t('s.geral.opcoes.bloqueado') },
            { label: 'C', value: t('s.geral.opcoes.cancelado') },
            { label: 'E', value: t('s.operacao.recebimento.cancelamento') },
          ]
        : [
            { label: 'L', value: t('s.geral.opcoes.liberado') },
            { label: 'B', value: t('s.geral.opcoes.bloqueado') },
            { label: 'C', value: t('s.geral.opcoes.cancelado') },
          ],
    []
  );

  const header = useMemo(() => {
    const data = [
      {
        id: 'idpreset',
        label: t('s.cadastro.preset.idpreset'),
        filter: { type: 'text' },
      },
      {
        id: 'nomepreset',
        label: t('s.cadastro.preset.nomepreset'),
        filter: { type: 'text' },
      },
      {
        id: 'idposto',
        label: t('s.geral.postocomboio'),
        filter: { type: 'text' },
      },
      {
        id: 'enderecopreset',
        label: t('s.cadastro.preset.enderecopreset'),
        filter: { type: 'text' },
      },
      {
        id: 'tipopreset',
        label: t('s.cadastro.preset.tipopreset'),
        filter: { type: 'text' },
      },
      {
        id: 'statuspreset',
        label: t('s.cadastro.pitstop.statusobservacao'),
        formatted: (value) => options.find((o) => o.label === value).value,
        filter: { type: 'select', options },
      },
    ];

    if (can(SKID)) {
      data.splice(7, 0, {
        id: 'mensagemerropreset',
        label: t('s.menu.cadastro.mensagem'),
        filter: { type: 'text' },
        align: 'left',
      });
    }

    return data;
  }, []);

  const fieldlist = [
    'idpreset',
    'nomepreset',
    'idposto',
    'enderecopreset',
    'tipopresetstr',
    'statuspreset',
    'portatcppreset',
    'conexaoclientepreset',
    'mensagemerropreset',
    'tipopreset',
  ];

  const substituirHeader = {
    idpreset: t('s.cadastro.preset.idpreset'),
    nomepreset: t('s.cadastro.preset.nomepreset'),
    idposto: t('s.geral.postocomboio'),
    enderecopreset: t('s.cadastro.preset.enderecopreset'),
    tipopresetstr: t('s.cadastro.preset.tipopreset'),
    statuspreset: t('s.cadastro.pitstop.statusobservacao'),
    codigonomeposto: t('s.geral.postocomboio'),
    ordempreset: t('s.cadastro.preset.ordempreset'),
    portatcppreset: t('s.cadastro.preset.portatcppreset'),
    conexaoclientepreset: t('s.cadastro.preset.conexaoclientepreset'),
    mensagemerropreset: t('s.menu.cadastro.mensagem'),
    tipopreset: t('s.cadastro.preset.tipopreset'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys={['idpreset', 'idposto']}
      detach="nomepreset"
      maxWidth="md"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'presets',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Presets',
          substituirValores: {
            statuspreset: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
              E: t('s.operacao.recebimento.cancelamento'),
            },
            conexaoclientepreset: {
              N: t('s.cadastro.preset.conexaoclientepresetservidor'),
              '  S': t('s.cadastro.preset.conexaoclientepreset'),
            },
          },
        })
      }
    />
  );
}

export default Preset;
